import axios from '@/plugins/axios'
import { auth } from '@/store/auth.module'

class PaymentService {
  // 결제 상품 목록
  async getPaymentList(type) {
    const { data } = await axios.get(`/sum/api/products/${type}`).then()
    return data
  }

  // 결제 상세 화면 조회
  async getPaymentDetail() {
    const { data } = await axios.get('/sum/api/payInfo').then()
    return data
  }

  // Solution 목록
  async getPaySolution() {
    const { data } = await axios.get('/sum/api/solutions').then()
    return data
  }

  async getLink(param) {
    const userSeqId = auth.state.user.userSeqId
    const formData = new FormData()
    formData.append('type', param.type)
    formData.append('intent', 'sale')
    formData.append('returnUrl', process.env.VUE_APP_CLIENT_URL + '/payment')
    formData.append('cancelUrl', process.env.VUE_APP_CLIENT_URL + '/payment')
    formData.append('paymentMethod', 'paypal')
    formData.append('total', param.payment)
    formData.append('currency', 'USD')
    formData.append('userSeqId', userSeqId)
    formData.append('productSeqId', param.productSeqId)

    const { data } = await axios.post('/sum/api/pay/link', formData).then()
    return data
  }

  async paymentDone(param) {
    const formData = new FormData()
    formData.append('paypalNo', param.paypalNo)
    formData.append('payerId', param.payerId)

    const { data } = await axios.post('/sum/api/pay/complete', formData).then()
    return data
  }

  async downloadReport(paySeqId) {
    const { data } = await axios
      .get('/sum/api/mail/report?paySeqId=' + paySeqId)
      .then()
    return data
  }
}

export default new PaymentService()
